/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T10:19:46.055
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveCCBFinBillItem,
	getCCBFinBillItemCreateInit,
	getCCBFinBillItemEditInit,
	getCCBFinBillItemView,
	deleteCCBFinBillItem
} from '@api/house/CCBFinBillItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getCCBFinBillItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBFinBillItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveCCBFinBillItem({}, CCBFinBillItem) {
			return new Promise((resolve, reject) => {
				saveCCBFinBillItem(CCBFinBillItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBFinBillItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBFinBillItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteCCBFinBillItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteCCBFinBillItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
